/**
 * Service for security grouping list operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapSecurityGroupListPagedResultToModel } from '../mappers';
import type {
  LC_SecurityGroupListOut,
  SecurityGroupListFilters,
  SecurityGroupListResult,
} from '../types';


export class SecurityGroupListService {
  /**
   * Get paginated list of security groups with optional filters
   */
  async list(
    filters?: SecurityGroupListFilters,
    signal?: AbortSignal,
  ): Promise<ApiResponse<SecurityGroupListResult>> {
    const queryString = buildQueryString(filters ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.SECURITY_GROUPING.LIST}${queryString}`;

    const response = await apiClient.get<LC_SecurityGroupListOut>(endpoint, { signal });

    if (response.success && response.data) {
      return {
        ...response,
        data: mapSecurityGroupListPagedResultToModel(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const securityGroupingListService = new SecurityGroupListService();
